/*
 * Copyright (C) 2019 Toshiba Corporation
 * SPDX-License-Identifier: Apache-2.0
 */

export interface FormatNode {
	format(target: number, step: number, date: Date): string;
}
